module.exports = __webpack_public_path__ + "static/media/3cost.67111208.svg";